import { BaseRequest } from './BaseRequest';

export class ResourceRequest extends BaseRequest {
    ResourceName: string | null;
    BotIdentifierDestination: string | null;
}